// src/components/Loading.js
import React from 'react';
import { motion } from 'framer-motion';

const Loading = () => {
  // Spinner Animation Variants
  const spinnerVariants = {
    animate: {
      rotate: 360,
      transition: {
        repeat: Infinity,
        duration: 1,
        ease: 'linear',
      },
    },
  };

  // Ripple Animation Variants
  const rippleVariants = {
    animate: {
      scale: [1, 2, 1],
      opacity: [0.5, 0, 0.5],
      transition: {
        repeat: Infinity,
        duration: 1.5,
        ease: 'easeInOut',
      },
    },
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <motion.div
        className="relative w-20 h-20"
        variants={spinnerVariants}
        animate="animate"
      >
        {/* Central Spinner */}
        <div className="absolute inset-0 border-4 border-custom-blue border-t-transparent rounded-full"></div>

        {/* Ripples */}
        <motion.div
          className="absolute inset-0 border-4 border-custom-blue border-t-transparent rounded-full"
          variants={rippleVariants}
          animate="animate"
        ></motion.div>
        <motion.div
          className="absolute inset-0 border-4 border-custom-blue border-t-transparent rounded-full"
          variants={rippleVariants}
          animate="animate"
          style={{ animationDelay: '0.3s' }}
        ></motion.div>
        <motion.div
          className="absolute inset-0 border-4 border-custom-blue border-t-transparent rounded-full"
          variants={rippleVariants}
          animate="animate"
          style={{ animationDelay: '0.6s' }}
        ></motion.div>
      </motion.div>
    </div>
  );
};

export default Loading;
